<div [hidden]="!active" class="p-2">
	<ng-content></ng-content>
	<!-- <ng-container *ngIf="component" [ngTemplateOutlet]="component" [ngTemplateOutletContext]="{ person: dataContext }">
	</ng-container> -->
	<ng-template #componentHost></ng-template>
</div>